import { PersistentSharedState } from '@trello/shared-state';
import { WorkspaceViewsQueryVariables } from './WorkspaceViewsQuery.generated';
import { memberId } from '@trello/session-cookie';

export interface WorkspaceViewNavigationState {
  filter: WorkspaceViewsQueryVariables['organizationViewsFilter'];
}

const initialState: WorkspaceViewNavigationState = {
  filter: ['team', 'private'],
};

export const workspaceViewNavigationState = new PersistentSharedState<WorkspaceViewNavigationState>(
  initialState,
  {
    storageKey: `workspaceViewNavigationState-${memberId ?? 'anonymous'}`,
  },
);
